import Axios from 'axios'

export default {
  namespaced: true,
  state: {
    player: null,
    removePlayerFromGroup: null,
    makeAsGroupAdmin: null,
    removeAsGroupAdmin: null,
    deletePlayer: null,
    deletePlayerLoading: false,
    changeGroupName: null
  },
  getters: {
    PLAYER: state => state.player,
    GET_REMOVE_PLAYER_FROM_GROUP: state => state.removePlayerFromGroup,
    GET_MAKE_AS_GROUP_ADMIN: state => state.makeAsGroupAdmin,
    GET_CHANGE_GROUP_NAME: state => state.changeGroupName,
    GET_REMOVE_AS_GROUP_ADMIN: state => state.removeAsGroupAdmin,
    DELETE_PLAYER_REPSONSE: state => state.deletePlayer,
    GET_DELETE_PLAYER_LOADING: state => state.deletePlayerLoading
  },
  mutations: {
    SET_PLAYER: (state, payload) => {
      state.player = payload
    },
    SET_REMOVE_PLAYER_FROM_GROUP: (state, payload) => {
      state.removePlayerFromGroup = payload
    },
    SET_MAKE_AS_GROUP_ADMIN: (state, payload) => {
      state.makeAsGroupAdmin = payload
    },
    SET_CHANGE_GROUP_NAME: (state, payload) => {
      state.changeGroupName = payload
    },
    SET_REMOVE_AS_GROUP_ADMIN: (state, payload) => {
      state.removeAsGroupAdmin = payload
    },
    SET_DELETE_PLAYER_REPSONSE: (state, payload) => {
      state.deletePlayer = payload
    },
    SET_DELETE_PLAYER_LOADING: (state, payload) => {
      state.deletePlayerLoading = payload
    }
  },
  actions: {
    GET_PLAYER: async (context, payload) => {
      try {
        const response = await Axios.get(`/player/${payload}`)
        context.commit('SET_PLAYER', response.data)
      } catch (error) {
        context.commit('SET_PLAYER', error.response.data)
      }
    },
    REMOVE_PLAYER_FROM_GROUP: async (context, payload) => {
      try {
        const response = await Axios.post(`/group/remove-player`, payload)
        context.commit('SET_REMOVE_PLAYER_FROM_GROUP', response.data)
      } catch (error) {
        context.commit('SET_REMOVE_PLAYER_FROM_GROUP', error.response.data)
      }
    },
    MAKE_AS_GROUP_ADMIN: async (context, payload) => {
      try {
        const response = await Axios.post(`/group/add-admin`, payload)
        context.commit('SET_MAKE_AS_GROUP_ADMIN', response.data)
      } catch (error) {
        context.commit('SET_MAKE_AS_GROUP_ADMIN', error.response.data)
      }
    },
    REMOVE_AS_GROUP_ADMIN: async (context, payload) => {
      try {
        const response = await Axios.post(`/group/remove-admin`, payload)
        context.commit('SET_REMOVE_AS_GROUP_ADMIN', response.data)
      } catch (error) {
        context.commit('SET_REMOVE_AS_GROUP_ADMIN', error.response.data)
      }
    },
    CHANGE_GROUP_NAME: async (context, payload) => {
      try {
        const response = await Axios.post(`/group/change-name`, payload)
        context.commit('SET_CHANGE_GROUP_NAME', response.data)
      } catch (error) {
        context.commit('SET_CHANGE_GROUP_NAME', error.response.data)
      }
    },
    DELETE_PLAYER: async (context, payload) => {
      try {
        context.commit('SET_DELETE_PLAYER_LOADING', true)

        const response = await Axios.post(`/player/delete`, payload)
        context.commit('SET_DELETE_PLAYER_REPSONSE', response.data)
        context.commit('SET_DELETE_PLAYER_LOADING', false)
      } catch (error) {
        context.commit('SET_DELETE_PLAYER_REPSONSE', error.response.data)
        context.commit('SET_DELETE_PLAYER_LOADING', false)
      }
    }
  }
}
